module.exports = __webpack_public_path__ + "static/img/wscpos.40ba460.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/wscpos.png
// module id = R/Wo
// module chunks = 0